<ion-header>
  <ion-toolbar class="gradient-primary-right">
    <ion-buttons slot="start">
      <ion-menu-button>
        <ion-icon class="icon-menu" color="dark" name="menu"></ion-icon>
        <app-inbox-count></app-inbox-count>
      </ion-menu-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'QRCODE.lbl.guest_qrcode' | translate }}
    </ion-title>
  </ion-toolbar>
  <ion-toolbar class="gradient-primary-right">
    <app-news-card-slide class="full-width" [newsCardSlideType]="'guest_qrcode'" [setReady]="ready"></app-news-card-slide>
  </ion-toolbar>
</ion-header>
<ion-content color="light" #content>
  <div class="content-div">
    <div class="main-div" *ngIf="quickSetup || newWebsiteMode else quickSetupBlock">
      <div>
        <div class="seg-div" *ngIf="invitedByList?.length > 1">
          <ion-segment [(ngModel)]="invitedBy" scrollable>
            <ion-segment-button value="">
              <ion-text>
                {{'LBL.all' | translate }}
              </ion-text>
            </ion-segment-button>
            <ng-container *ngIf="invitedByList">
              <ion-segment-button [value]="invited" *ngFor="let invited of invitedByList">
                <ion-text>
                  <ng-container *ngIf="invited.custom">{{ invited.value }}</ng-container>
                  <ng-container *ngIf="!invited.custom">
                    {{ 'LIST.invited_by.' + invited.value | translate }}
                  </ng-container>
                </ion-text>
              </ion-segment-button>
            </ng-container>
          </ion-segment>
        </div>
      
        <ion-grid class="ion-no-padding" fixed>
          <ion-row>
            <ion-col>
              <app-guest-statistic-item class="full-width" [status]="{ qrcode: true }" [setQrcodeType]="'sent'" [setInvitedBy]="invitedBy" [name]="'LIST.send_status.sent' | translate" [statisticType]="'qrcode'" [all]="true" [cardType]="'rect'" [showPercent]="true" [color]="'tertiary'" [whiteBackground]="true"></app-guest-statistic-item>
            </ion-col>
            <ion-col>
              <app-guest-statistic-item class="full-width" [status]="{ qrcode: false }" [setQrcodeType]="'not_send'" [setInvitedBy]="invitedBy" [name]="'LIST.send_status.not_send' | translate" [statisticType]="'qrcode'" [all]="true" [cardType]="'rect'" [showPercent]="true" [color]="'grey'" [whiteBackground]="true"></app-guest-statistic-item>
            </ion-col>
          </ion-row>
        </ion-grid>
      </div>
  
      <div class="ion-padding-vertical">
        <ion-card class="ion-padding-vertical ion-no-margin" color="tertiary" (click)="presentVisitorPageModal()" button>
          <ion-item color="tertiary" lines="none">
            <ion-img slot="start" class="preview-img" src="./assets/wedding/img/qrcode/preview.webp"></ion-img>
            <ion-label slot="end" class="font-12 font-med" color="dark">{{ 'QRCODE.btn.preview' | translate }}</ion-label>
          </ion-item>
        </ion-card>
      </div>
  
      <div class="ion-padding-vertical">
        <swiper-container class="setting-swiper ion-padding-vertical" [slidesPerView]="slidePerView" *ngIf="currentPrivilege?.[module]?.['qrcode']">
          <swiper-slide>
            <ion-item class="background-transparent ion-item-no-padding" lines="none">
              <ion-label class="ion-text-center ion-no-margin">
                <div class="vertical-center">
                  <ion-img class="setting-img center" (click)="presentVisitorSettingWizard()" src="./assets/wedding/img/qrcode/quick-setup.webp"></ion-img>
                </div>
                <div class="margin-top-6 ion-text-center vertical-center">
                  <ion-text class="font-10 ion-text-wrap" color="dark" (click)="presentVisitorSettingWizard()">{{ 'VISITOR.wizard.quick_setup' | translate }}</ion-text>
                </div>
              </ion-label>
            </ion-item>
          </swiper-slide>
          <swiper-slide>
            <ion-item class="background-transparent ion-item-no-padding" lines="none">
              <ion-label class="ion-text-center ion-no-margin">
                <div class="vertical-center">
                  <ion-img class="setting-img center" (click)="presentVisitorSettingModal('info')" src="./assets/wedding/img/qrcode/info.webp"></ion-img>
                </div>
                <div class="margin-top-6 ion-text-center vertical-center">
                  <ion-text class="font-10 ion-text-wrap" color="dark" (click)="presentVisitorSettingModal('info')">{{ 'LBL.info' | translate }}</ion-text>
                </div>
              </ion-label>
            </ion-item>
          </swiper-slide>
          <swiper-slide>
            <ion-item class="background-transparent ion-item-no-padding" lines="none">
              <ion-label class="ion-text-center ion-no-margin">
                <div class="vertical-center">
                  <ion-img class="setting-img center" (click)="presentVisitorSettingModal('theme')" src="./assets/wedding/img/qrcode/theme.webp"></ion-img>
                </div>
                <div class="margin-top-6 ion-text-center vertical-center">
                  <ion-text class="font-10 ion-text-wrap" color="dark" (click)="presentVisitorSettingModal('theme')">{{ 'LBL.theme' | translate }}</ion-text>
                </div>
              </ion-label>
            </ion-item>
          </swiper-slide>
          <swiper-slide>
            <ion-item class="background-transparent ion-item-no-padding" lines="none">
              <ion-label class="ion-text-center ion-no-margin">
                <div class="vertical-center">
                  <ion-img class="setting-img center" (click)="presentVisitorSettingModal('setting')" src="./assets/wedding/img/qrcode/setting.webp"></ion-img>
                </div>
                <div class="margin-top-6 ion-text-center vertical-center">
                  <ion-text class="font-10 ion-text-wrap" color="dark" (click)="presentVisitorSettingModal('setting')">{{ 'MENU.setting' | translate }}</ion-text>
                </div>
              </ion-label>
            </ion-item>
          </swiper-slide>
        </swiper-container>
      </div>
      
      <div>
        <ion-button expand="block" (click)="presentGuestListModal('not_send')" *ngIf="currentPrivilege?.[module]?.['qrcode']">
          {{ 'QRCODE.btn.send' | translate }}
        </ion-button>
      </div>
    </div>
    <ng-template #quickSetupBlock>
      <div class="full-width-height ion-padding vertical-center">
        <div class="full-width ion-padding">
          <div class="ion-margin ion-text-center">
            <ion-text class="font-18 font-med">{{ 'VISITOR.wizard.intro.title' | translate }}</ion-text>
          </div>
          <div class="ion-margin ion-padding">
            <ion-img class="quick-setup-img ion-margin center" src="./assets/wedding/img/visitor/wizard/intro.webp"></ion-img>
          </div>
          <div class="ion-margin ion-text-center">
            <ion-text class="font-12">{{ 'VISITOR.wizard.intro.intro' | translate }}</ion-text>
          </div>
          <div class="full-width ion-padding">
            <ion-button class="ion-margin" expand="block" (click)="presentVisitorSettingWizard()">
              {{ 'VISITOR.wizard.quick_setup' | translate }}
            </ion-button>
          </div>
        </div>
      </div>
    </ng-template>
  </div>
</ion-content>